import type { CTA, Entry, Link } from '@libs/contentful';
import { PRIMARY_BUTTON_STYLE, SECONDARY_BUTTON_STYLE } from '@libs/contentful';

export type CTAWithLinkEntry = Omit<CTA, 'link'> & {
    link: Entry<Link>;
};

export const getButtonVariant = (cta: { fields: CTAWithLinkEntry }) => {
    const buttonStyle = cta && cta.fields.buttonStyle?.toLowerCase();
    return buttonStyle === 'primary' ? PRIMARY_BUTTON_STYLE : SECONDARY_BUTTON_STYLE;
};
